"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "feuds", {
    enumerable: true,
    get: function() {
        return feuds;
    }
});
const feuds = [
    {
        id: "rr-cr",
        name: "Nightmare Aknowledgement",
        startDate: new Date("Jan 30 2023"),
        endDate: new Date("Apr 30 2024"),
        wrestlerIds: [
            "roman-reigns",
            "cody-rhodes"
        ],
        winnerIds: [
            "roman-reigns"
        ],
        brandIds: [
            "smackdown"
        ],
        championshipIds: [
            "uni-world",
            "wwe-title"
        ],
        storylineId: 9,
        stageId: 5,
        complete: false
    },
    {
        id: "drew-punk",
        name: "Bitter Rivals",
        startDate: new Date("Oct 10 2023"),
        endDate: new Date("December 01 2024"),
        wrestlerIds: [
            "cm-punk",
            "drew-mcintyre"
        ],
        brandIds: [
            "raw"
        ],
        storylineId: 1,
        stageId: 2,
        complete: false
    },
    {
        id: "gunthervmiz",
        name: "Laughing Stock",
        startDate: new Date("Nov 1 2023"),
        endDate: new Date("Dec 31 2023"),
        wrestlerIds: [
            "gunther",
            "the-miz"
        ],
        championshipIds: [
            "ic"
        ],
        brandIds: [
            "raw"
        ],
        storylineId: 1,
        complete: true
    },
    {
        id: "lk-rr",
        name: "Time is now?",
        startDate: new Date("Sept 29 2023"),
        endDate: new Date("Nov 8 2023"),
        wrestlerIds: [
            "la-knight",
            "roman-reigns"
        ],
        brandIds: [
            "smackdown"
        ],
        championshipIds: [
            "uni-world"
        ],
        storylineId: 1,
        complete: true
    },
    {
        id: "br-vs-br",
        name: "Brother vs Brother",
        startDate: new Date("January 1 2024"),
        endDate: new Date("May 1 2024"),
        wrestlerIds: [
            "jey-uso",
            "jimmy-uso"
        ],
        brandIds: [
            "smackdown",
            "raw"
        ],
        storylineId: 1,
        complete: false
    },
    {
        id: "ts-bl",
        name: "Disrespect",
        startDate: new Date("Apr 01 2023"),
        endDate: new Date("Sept 02 2023"),
        wrestlerIds: [
            "trish-stratus",
            "becky-lynch"
        ],
        brandIds: [
            "raw"
        ],
        storylineId: 1,
        complete: true
    }
];
